/* global IS_PRODUCTION */

import axios from '@/js/helper/axios-helper.js'
import { stringify } from 'qs'
// import { asyncForEach } from '@/js/helper/async-helper'

import ACTION_TYPES from './action-types'
import MUTATION_TYPES from './mutation-types'
import SEARCH_DETAIL_CONSTANTS from '@/js/helper/search-detail-link-constants.js'

import { types as STOREMODULES } from '@/js/plugins/store/store-modules.js'
import APP_GETTERS from '@/js/plugins/store/modules/app/getter-types'

export default {
  [ACTION_TYPES.FETCH_AVAILABILITIES]: async (
    { commit },
    { id = [], sku = [], itemids = [], type },
  ) => {
    const data = {
      selectids: Array.isArray(id) ? id : [id],
      skus: Array.isArray(sku) ? sku : [sku],
      itemids: Array.isArray(itemids) ? itemids : [itemids],
    }

    const requestUrl = `${window.location.origin}/api/bucommonapi?code=availability&${stringify(
      data,
    )}`

    const params =
      requestUrl.length > 2048
        ? {
            method: 'POST',
            url: `${window.location.origin}/api/bucommonapi?code=availability`,
            data,
          }
        : {
            method: 'GET',
            url: requestUrl,
          }

    try {
      const { data: availabilities } = await axios(params)
      commit(MUTATION_TYPES.SET_AVAILABILITIES, { availabilities, type })
    } catch (error) {
      // TODO: Error Handling
      if (!IS_PRODUCTION) {
        console.error(error)
      }
    }

    // asyncForEach(ids, async id => {
    //   // TODO: url from app_config!
    //   const requestUrl = `${window.location.origin}/api/bucommonapi?code=availability&${id}=${id}`

    //   try {
    //     const { data: availabilities } = await axios.get(requestUrl)

    //     // TODO: Research thread decoupling for mutation
    //     setTimeout(() => {
    //       commit(MUTATION_TYPES.SET_AVAILABILITIES, { availabilities, type })
    //     }, 10)
    //   } catch (error) {
    //     // TODO: Error Handling
    //     if (!IS_PRODUCTION) {
    //       console.error(error)
    //     }
    //   }
    // })
  },
  [ACTION_TYPES.CLEAR_AVAILABILITIES_BY_TYPE]: ({ commit }, type) => {
    commit(MUTATION_TYPES.CLEAR_AVAILABILITIES_BY_TYPE, type)
  },
  [ACTION_TYPES.SET_DETAILPAGE_TO_SPAREPARTS_DETAIL]: ({ commit, rootGetters }, catId) => {
    const url = rootGetters[`${STOREMODULES.APP}/${APP_GETTERS.SPAREPARTS_DETAIL_URL}`]
    commit(
      MUTATION_TYPES.SET_DETAILPAGE_URL,
      `${url}${/\?/.test(url) ? '&' : '?'}${
        SEARCH_DETAIL_CONSTANTS.FE_BACK_LINK
      }=${encodeURIComponent(window.location)}${catId ? `&ai%5Bf_catid%5D=${catId}` : ''}`,
    )
  },
}
